import { emptyNull } from '../../../shared/misc';
import storageAndCookie from '../../../global-utils/storage-and-cookies';
import { SEEN_PREFIX, SEEN_DAYS } from './constants';

import { defaultDurationSeconds } from '../../../modules/notification';

const seenName = (id) => `${SEEN_PREFIX}${id}`;

// A real-time toast is shown at most once; dismissal is tracked via a cookie
// (mirrors the advertisement popup's cookie-based suppression).
export const wasSeen = (id) => storageAndCookie.get(seenName(id), true) === `${id}`;
export const markSeen = (id) => storageAndCookie.set(seenName(id), `${id}`, SEEN_DAYS, true);

// Notifications arrive with inconsistent casing depending on the source
// (live API vs. SignalR payload vs. static fallback), so read defensively.
export const notificationId = (n = emptyNull) => n.id ?? n.Id ?? n.notificationId ?? n.NotificationId;
export const notificationTitle = (n = emptyNull) => n.title ?? n.Title ?? n.name ?? n.Name ?? '';
export const notificationText = (n = emptyNull) => n.text ?? n.Text ?? n.message ?? n.Message ?? n.description ?? n.Description ?? '';
export const notificationLink = (n = emptyNull) => n.link ?? n.Link ?? n.url ?? n.Url ?? n.optionalLink ?? n.OptionalLink ?? '';
export const notificationColor = (n = emptyNull) => n.backgroundColor ?? n.BackgroundColor ?? null;
export const notificationImage = (n = emptyNull) => n.image ?? n.Image ?? null;

// Duration (ms) the toast stays visible. Priority:
// 1. Backend's per-notification `ShowInSeconds`
// 2. Admin module's `defaultDurationSeconds` setting (default 30 s)
export const notificationDuration = (n = emptyNull) => {
  const seconds = Number(n.showInSeconds ?? n.ShowInSeconds ?? 0);
  return seconds > 0 ? seconds * 1000 : defaultDurationSeconds() * 1000;
};
